import { remoteConfig } from '@/configs/firebaseConfig';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { useEffect, useState } from 'react';

export default function useShowChart() {
    const [showChart, setShowChart] = useState(false);
    const [showAds, setShowAds] = useState(false);

    useEffect(() => {
        async function loadConfig() {
            try {
                // Default value để fallback
                remoteConfig.defaultConfig = {
                    winance_chart_on: '0',
                    winance_banner_on: '0',
                };

                remoteConfig.settings = {
                    minimumFetchIntervalMillis: 0, // Cho phép fetch ngay (không cần chờ 12h)
                    fetchTimeoutMillis: 60000, // Timeout 60s (bắt buộc phải có)
                };
                await fetchAndActivate(remoteConfig);

                const value = getValue(
                    remoteConfig,
                    'winance_chart_on'
                ).asString();
                setShowChart(value === '1');

                const valueAds = getValue(
                    remoteConfig,
                    'winance_banner_on'
                ).asString();
                setShowAds(valueAds === '1');
            } catch (err) {
                console.error('Remote Config error:', err);
            }
        }

        loadConfig();
    }, []);

    return { showChart, showAds };
}
